module.exports = __webpack_public_path__ + "img/mainClientPersonas.34c86d5e.svg";